<template>
	<img src="@/assets/sc-icon.png" />
</template>

<script>
export default {
  data: function() {
    return {
      // greeting: "Hello"
    };
  }
};
</script>

<style scoped>
img {
	width:20px;
}
</style>
